// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3QleL","label":"SetPasswdForm_label__HlFtA"};